/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Experience_Findus_Proptech_MetricsInputs */

const en_experience_findus_proptech_metrics = /** @type {(inputs: Experience_Findus_Proptech_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design system leadership`)
};

const ar_experience_findus_proptech_metrics = /** @type {(inputs: Experience_Findus_Proptech_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قيادة نظام التصميم`)
};

const bn_experience_findus_proptech_metrics = /** @type {(inputs: Experience_Findus_Proptech_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডিজাইন সিস্টেম নেতৃত্ব`)
};

const de_experience_findus_proptech_metrics = /** @type {(inputs: Experience_Findus_Proptech_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design-Systemführung`)
};

const es_experience_findus_proptech_metrics = /** @type {(inputs: Experience_Findus_Proptech_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liderazgo del sistema de diseño`)
};

const fr_experience_findus_proptech_metrics = /** @type {(inputs: Experience_Findus_Proptech_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leadership du système de conception`)
};

const pt_experience_findus_proptech_metrics = /** @type {(inputs: Experience_Findus_Proptech_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liderança do sistema de design`)
};

const zh_experience_findus_proptech_metrics = /** @type {(inputs: Experience_Findus_Proptech_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设计系统领导力`)
};

const tr_experience_findus_proptech_metrics = /** @type {(inputs: Experience_Findus_Proptech_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tasarım sistemi liderliği`)
};

const ru_experience_findus_proptech_metrics = /** @type {(inputs: Experience_Findus_Proptech_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лидерство в дизайн-системе`)
};

const pl_experience_findus_proptech_metrics = /** @type {(inputs: Experience_Findus_Proptech_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przywództwo w zakresie projektowania systemów`)
};

/**
* | output |
* | --- |
* | "Design system leadership" |
*
* @param {Experience_Findus_Proptech_MetricsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const experience_findus_proptech_metrics = /** @type {((inputs?: Experience_Findus_Proptech_MetricsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Experience_Findus_Proptech_MetricsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_experience_findus_proptech_metrics(inputs)
	if (locale === "bn") return bn_experience_findus_proptech_metrics(inputs)
	if (locale === "de") return de_experience_findus_proptech_metrics(inputs)
	if (locale === "es") return es_experience_findus_proptech_metrics(inputs)
	if (locale === "fr") return fr_experience_findus_proptech_metrics(inputs)
	if (locale === "pt") return pt_experience_findus_proptech_metrics(inputs)
	if (locale === "zh") return zh_experience_findus_proptech_metrics(inputs)
	if (locale === "tr") return tr_experience_findus_proptech_metrics(inputs)
	if (locale === "ru") return ru_experience_findus_proptech_metrics(inputs)
	if (locale === "pl") return pl_experience_findus_proptech_metrics(inputs)
	return en_experience_findus_proptech_metrics(inputs)
});